<template>
  <v-layout row justify-center>
    <v-dialog v-model="dialog" persistent full-width>
      <v-card>
        <v-card-title>
          <span class="title">{{ title }}</span>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
        <v-form v-model="valid" ref="form" lazy-validation>
          <v-container grid-list-md>
            <v-layout row wrap>
              <v-flex xs12 md5>
                <v-text-field 
                  label="รหัสวิชา" 
                  v-model="item.code" 
                  :rules="[rules.required]" 
                  required
                ></v-text-field>
                <v-text-field 
                  label="ชื่อวิชา (ไทย)" 
                  v-model="item.nameTh" 
                  :rules="[rules.required]" 
                  required
                ></v-text-field>
                <v-text-field 
                  label="ชื่อวิชา (อังกฤษ)" 
                  v-model="item.nameEn" 
                ></v-text-field>

                <v-textarea multi-line label="คำอธิบาย (ไทย)" v-model="item.descriptionTh"></v-textarea>
                <v-textarea multi-line label="คำอธิบาย (อังกฤษ)" v-model="item.descriptionEn"></v-textarea>
              </v-flex>

              <v-flex xs12 md6 offset-md1>
                <v-layout row wrap>
                  <v-flex xs12 md2>
                    <v-text-field mask="#" label="หน่วยกิต" v-model="item.credit" :rules="[rules.required]" required></v-text-field>
                  </v-flex>
                  <v-flex xs12 md2>
                    <v-text-field mask="#" label="ทฤษฎี" v-model="item.theoryUnit" :rules="[rules.required]" required></v-text-field>
                  </v-flex>
                  <v-flex xs12 md2>
                    <v-text-field mask="#" label="ปฏิบัติ" v-model="item.practiceUnit" :rules="[rules.required]" required></v-text-field>
                  </v-flex>
                  <v-flex xs12 md3>
                    <v-text-field mask="#" label="ศึกษาด้วยตนเอง" v-model="item.selfUnit" :rules="[rules.required]" required></v-text-field>
                  </v-flex>
                  <v-flex xs12 md3>
                    <v-text-field mask="#" label="ชั่วโมง/สัปดาห์" v-model="item.hourPerWeek" :rules="[rules.required]" required></v-text-field>
                  </v-flex>
                </v-layout>

                <v-select
                  v-bind:items="subjectTypeItems"
                  v-model="item.subjectType"
                  label="กลุ่มวิชา"
                  item-text="text"
                  item-value="id"
                  light
                  :rules="[rules.required]"
                  required
                ></v-select>

                <v-textarea multi-line label="หมายเหตุ" v-model="item.remark"></v-textarea>
              </v-flex>
              
            </v-layout>
          </v-container>
        </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn color="grey white--text" :loading="loading" :disabled="loading" @click.native="close">ยกเลิก</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="success" :loading="loading" :disabled="loading" @click.native="onSave">บันทึก</v-btn>
        </v-card-actions>
        
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import swal from 'sweetalert2'

export default {
  props: ['dialog', 'item', 'title'],
  data () {
    return {
      loading: false,
      valid: false,
      rules: {
        required: (value) => !!value || 'ไม่สามารถเป็นค่าว่าง'
      },
      subjectTypeItems: [
        { id: 'MANDATORY', text: 'บังคับ' },
        { id: 'ELECTIVE', text: 'บังคับเลือก' }
      ]
    }
  },
  methods: {
    close: function() {
      this.$emit('dialog', false)
    },
    onSave () {
      console.log('onSave called...', this.item )
      if (this.$refs.form.validate()) {
        this.loading = true
        let dispatch = this.item.id && this.item.id > 0 ? 'subject/update' : 'subject/create' 
        // console.log('dispatch', dispatch )
        this.$store.dispatch(dispatch, this.item)
          .then((response) => {
            console.log('onSave:', response )
            this.loading = false
            this.close()
          }).catch((error) => {
            this.loading = false
            swal('Error!', error.message, 'error')
          })
      }
    }
    
  },
  watch: {
    
  }
}

</script>


// WEBPACK FOOTER //
// src/components/settings/subject/formDialog.vue